module.exports = __webpack_public_path__ + "static/media/msd-dashboard-logo.b25c55e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/msd-dashboard-logo.png
// module id = 649
// module chunks = 0